module.exports = __webpack_public_path__ + "static/media/skepp-min.1e29bcad.png";